import { isNotNil } from '@flowio/is';
import getOwnerWindow from './getOwnerWindow';
/**
 * Get all style properties for the specified element.
 * @param element The element for which to get the styles.
 */

function getStyles(element) {
  var window = getOwnerWindow(element);
  return isNotNil(window) ? window.getComputedStyle(element, null) : null;
}

export default getStyles;
//# sourceMappingURL=getStyles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/blaze-consumer/~/@flowio/browser-helpers/lib/esm/getStyles.js
// module id = 190
// module chunks = 0 1